export type NotificationSeverity = "success" | "error" | "warning" | "info";

export interface NotificationPayload {
    title?: string;
    message?: string;
    icon?: NotificationSeverity | string;
    timer?: number;
}

type Listener = (payload: NotificationPayload) => void;

const listeners: Listener[] = [];

export const onNotification = (fn: Listener): (() => void) => {
    listeners.push(fn);
    return () => {
        const idx = listeners.indexOf(fn);
        if (idx > -1) listeners.splice(idx, 1);
    };
};

export const emitNotification = (payload: NotificationPayload): void => {
    listeners.forEach((fn) => fn(payload));
};
